import { render, staticRenderFns } from "./PxAutocompleteUserGrupo.vue?vue&type=template&id=7fb7b373&"
import script from "./PxAutocompleteUserGrupo.vue?vue&type=script&lang=js&"
export * from "./PxAutocompleteUserGrupo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
installComponents(component, {VAutocomplete})
